// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"9fc93c6f","423":"fd7c01f4","617":"e831afc1","660":"c132abe9","821":"9514c742","914":"09397ffa"}[chunkId] + ".chunk.js";
};